const brlFmt = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
});

const numFmt = new Intl.NumberFormat("pt-BR", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

function toNumber(v: string | number | null | undefined): number {
  if (v === null || v === undefined || v === "") return 0;
  if (typeof v === "number") return Number.isFinite(v) ? v : 0;
  const n = Number(String(v).replace(",", "."));
  return Number.isFinite(n) ? n : 0;
}

export function formatarMoedaBRL(valor: string | number | null | undefined): string {
  return brlFmt.format(toNumber(valor));
}

export function formatarNumero(valor: string | number | null | undefined): string {
  return numFmt.format(toNumber(valor));
}

/** Razão 0–1 ou percentual já em 0–100. */
export function formatarPercentual(
  valor: string | number | null | undefined,
  opts?: { jaEhPercentual?: boolean },
): string {
  const n = toNumber(valor);
  const ratio = opts?.jaEhPercentual ? n / 100 : n;
  const pct = ratio <= 1 && ratio >= -1 ? ratio * 100 : n;
  return `${numFmt.format(pct)}%`;
}

/** Interpreta valor digitado (pt-BR ou ponto decimal). Retorna NaN se inválido. */
export function parseValorMonetarioInput(raw: string): number {
  const t = raw.trim().replace(/\s/g, "");
  if (!t) return Number.NaN;
  if (t.includes(",")) {
    const s = t.replace(/\./g, "").replace(",", ".");
    const n = Number(s);
    return Number.isFinite(n) ? n : Number.NaN;
  }
  const n = Number(t);
  return Number.isFinite(n) ? n : Number.NaN;
}
